import { render, staticRenderFns } from "./EnvironmentForm.vue?vue&type=template&id=13ae4535"
import script from "./EnvironmentForm.vue?vue&type=script&lang=js"
export * from "./EnvironmentForm.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentForm.vue?vue&type=style&index=0&id=13ae4535&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports